import { render, staticRenderFns } from "./RestorePasswordForm.vue?vue&type=template&id=3a48707c&scoped=true&"
import script from "./RestorePasswordForm.vue?vue&type=script&lang=js&"
export * from "./RestorePasswordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a48707c",
  null
  
)

export default component.exports